import React from "react";
import styled from "styled-components";
import { color, flexCenter } from "../styles/theme";

const LoadingSection = styled.section`
	width: 100vw;
	height: 100vh;
	z-index: 9999;
	position: fixed;
	top: 0;
	left: 0;
	background: #444343b4;
	filter: blur(0.3);
`;

const LoadingItem = styled.div`
	${flexCenter}

	box-sizing: border-box;
	position: absolute;
	top: 50%;
	left: 50%;
	width: 64px;
	height: 64px;
	margin-top: -32px;
	margin-left: -32px;
	border-radius: 50%;
	border: 3px solid transparent;
	border-top-color: ${color.white};
	border-bottom-color: ${color.purple};
	animation: loading 0.8s ease infinite;

	@keyframes loading {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}
`;

const Loading = () => {
	return (
		<LoadingSection>
			<LoadingItem></LoadingItem>
		</LoadingSection>
	);
};

export default Loading;
